import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#vp-mortgage-payment-lite-app', App);
